import {Header, Tabs} from '@/components';
import SystemHealthBanner from '@/components/SystemHealthBanner';
import type {TabItem} from '@/types';

import ProcessorList from './ProcessorList';

const ProcessorCorridors = () => {
  const configTabs: TabItem[] = [
    {
      id: 'retail',
      title: 'Retail Processors(B2C)',
      content: <ProcessorList target="user" />,
    },
    {
      id: 'portal',
      title: 'Portal Processors(B2B)',
      content: <ProcessorList target="business" />,
    },
    {
      id: 'currenciesList',
      title: 'API Processors(B2B)',
      content: <ProcessorList target="api" />,
    },
  ];
  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title="Processor Corridors" />
      <SystemHealthBanner reason="Check how a rail is actually performing before changing which processor serves a corridor. The system health dashboard shows each rail's payout failure and refund rate over the last day, and which partners are rejecting calls." />
      <Tabs tabs={configTabs} />
    </main>
  );
};

export default ProcessorCorridors;
